import React from 'react'
import { Textarea } from '@chakra-ui/react'

export default (props) => {
  return <Textarea {...props} />
}
